import type { PropType } from 'vue';
import type { DomClassesProp } from '@/typings/class-style-binding';
import type { Sizes, ModalTab } from '@/components/AppModal/index.d';

export const footerProps = {
  withCloseButton: {
    type: Boolean as PropType<boolean>,
    default: true,
  },

  withSubmitButton: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  closeButtonText: {
    type: String as PropType<string>,
    default: null,
  },

  submitButtonText: {
    type: String as PropType<string>,
    default: null,
  },

  closeButtonDisabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  submitButtonDisabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  submitting: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  extendedSubmitButtonDomClasses: {
    type: [String, Array, Object] as PropType<DomClassesProp>,
    default: null,
  },
};

export default {
  title: {
    type: String as PropType<string>,
    default: null,
  },

  unmount: {
    type: Boolean as PropType<boolean>,
    default: true,
  },

  static: {
    type: Boolean as PropType<boolean>,
    default: false,
  },

  extendedDialogWrapperDomClasses: {
    type: [String, Array, Object] as PropType<DomClassesProp>,
    default: null,
  },

  extendedHeaderDomClasses: {
    type: [String, Array, Object] as PropType<DomClassesProp>,
    default: null,
  },

  extendedFooterDomClasses: {
    type: [String, Array, Object] as PropType<DomClassesProp>,
    default: null,
  },

  extendedBodyDomClasses: {
    type: [String, Array, Object] as PropType<DomClassesProp>,
    default: null,
  },

  size: {
    type: String as PropType<Sizes>,
    default: 'large',
    validator(this: void, size: string): boolean {
      return ['small', 'medium', 'large'].includes(size);
    },
  },

  tabs: {
    type: Array as PropType<ModalTab[]>,
    default: null,
  },

  unmountInactiveTabs: {
    type: Boolean as PropType<boolean>,
    default: true,
  },

  initialActiveTab: {
    type: String as PropType<ModalTab['name']>,
    default: null,
  },

  ...footerProps,
} as const;
